/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 PRO React components
import MDBox from "../MDBox";
import MDTypography from "../MDTypography";

function CheckBox({ id, checked, onChange, disabled }) {
  return (
    <MDBox display="flex" alignItems="center">
      <Checkbox checked={checked} onChange={onChange} disabled={disabled} />
      <MDBox ml={1}>
        <MDTypography variant="caption" fontWeight="medium" color="text">
          {id}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

// Setting default value for the props of IdCell
CheckBox.defaultProps = {
  checked: false,
};

// Typechecking props for the CheckBox
CheckBox.propTypes = {
  id: PropTypes.any.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default CheckBox;
